import React from "react";

import { classNames as cn } from "@features/utils/reactFunctions";
import { Space, Tag } from "antd";

import * as styles from "./PercentageBtnsStyle.module.scss";

type Props = {
  handleAmountPercentage: (amount: number) => Promise<void>;
  selectedTag: string;
};

const PercentageBtns = ({ handleAmountPercentage, selectedTag }: Props) => (
  <Space className={styles.wrapper} style={{ justifyContent: "space-around" }}>
    <Tag
      className={cn(selectedTag === "25" && styles.tabSelected)}
      onClick={() => handleAmountPercentage(25)}
    >
      25%
    </Tag>
    <Tag
      className={cn(selectedTag === "50" && styles.tabSelected)}
      onClick={() => handleAmountPercentage(50)}
    >
      50%
    </Tag>
    <Tag
      className={cn(selectedTag === "75" && styles.tabSelected)}
      onClick={() => handleAmountPercentage(75)}
    >
      75%
    </Tag>
    <Tag
      className={cn(selectedTag === "100" && styles.tabSelected)}
      onClick={() => handleAmountPercentage(100)}
    >
      100%
    </Tag>
  </Space>
);

export default PercentageBtns;
